/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { MouseEvent } from "react";
import { Button, theme, SVGIconProps } from "@nordcloud/gnui";

type Props = {
  children: React.ReactNode;
  icon?: SVGIconProps["name"];
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  linkTo?: string;
};

function PopoverMenuButton({ children, icon, onClick, linkTo }: Props) {
  return (
    <Button
      size="md"
      icon={icon}
      severity="low"
      css={{ backgroundColor: theme.color.background.ui01, width: "100%" }}
      onClick={onClick}
      linkTo={linkTo}
    >
      {children}
    </Button>
  );
}

export { PopoverMenuButton };
